import { Signup } from "./signup";

export class Footer {

	setupFooterSignup() {
		const signup = new Signup();

		//Get the signup form elements
		const nameInput = document.getElementById("footer-name") as HTMLInputElement;

		if(!nameInput) {
			throw new Error("Footer name input element with id='footer-name' not found");
		}

		const emailInput = document.getElementById("footer-email") as HTMLInputElement;

		if(!emailInput) {
			throw new Error("Footer email input element with id='footer-email' not found");
		}

		const subscribeButton = document.getElementById("footer-subscribe-btn") as HTMLButtonElement;

		if(!subscribeButton) {
			throw new Error("Footer subscribe button element with id='footer-subscribe-btn' not found");
		}

		const subscribeErrorMessage = document.getElementById("footer-subscribe-error-message") as HTMLDivElement;

		if(!subscribeErrorMessage) {
			throw new Error("Footer subscribe error message element with id='footer-subscribe-error-message' not found");
		}

		signup.setupSignup(nameInput, emailInput, subscribeButton, subscribeErrorMessage);
	}
}